import { Card, Tooltip } from '@nextui-org/react';
import React from 'react';
import Typography from '../../common/Typography';
import theme from '../../../theme';
import Button from '../../common/Button';
import { getCalculationResultColor, getCalculationResultRange } from '../../../../service/calculation';
import { formatDate } from '../../../../helpers/utils';
import IconButton from '../../common/IconButton';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Calculation } from '../../../../types/calculation';

interface Props {
  style?: React.CSSProperties;
  calculate: () => void;
  calculateDisabled: boolean;
  loading?: boolean;
  calculationResult: Calculation | null;
  onAssign: () => void;
  assignDisabled: boolean;
  onDownloadReport: () => void;
  downloadDisabled: boolean;
}

export default function InterviewResultHeader({
  style,
  calculate,
  onDownloadReport,
  downloadDisabled,
  calculateDisabled,
  assignDisabled,
  onAssign,
  loading,
  calculationResult
}: Props) {
  return (
    <Card
      shadow='none'
      style={{border: `1.5px solid lightgray`, height: '130px', paddingBottom: theme.sizing.x3, ...style}}
      /* className='flex justify-between px-4 pb-6 pt-4' */>
        <div className='flex justify-between px-4 pb-6 pt-4 items-center gap-52'>
          <div className='flex flex-col gap-2 flex-1'>
            <Typography colorVariant='primary'>Esito compatibilità</Typography>
            <div className='flex justify-between flex-1'>
              <div className='flex flex-col'>
                <Typography variant='label' colorVariant='textLabel'>Data</Typography>
                <Typography variant='button' style={{fontWeight: 700}}>{calculationResult ? formatDate(calculationResult.tsCreated) : '-------'}</Typography>
              </div>
              <div className='flex flex-col'>
                <Typography variant='label' colorVariant='textLabel'>Esito calcolo</Typography>
                <Typography variant='button' style={{fontWeight: 700, color: calculationResult ? getCalculationResultColor(calculationResult.result) : undefined}}>{calculationResult?.stringResult ?? '-------'}</Typography>
              </div>
              <div className='flex flex-col'>
                <Typography variant='label' colorVariant='textLabel'>Percentuale compatibilità</Typography>
                <Typography variant='button' style={{fontWeight: 700}}>{calculationResult?.result ? calculationResult.result.toFixed(2) : '--,--'} %</Typography>
              </div>
            </div>
          </div>
          <div className='flex gap-4'>
            <Button 
              loading={loading}
              disabled={calculateDisabled}
              title="CALCOLA COMPATIBILITA'"
              onClick={calculate}/>
            <Tooltip content="Assegna badante">
              <IconButton 
                disabled={assignDisabled}
                backgroundColorVariant='primary'
                icon={<GroupAddIcon style={{color: theme.color.background }}/>}
                onClick={onAssign} />
            </Tooltip>
            <Tooltip content="Scarica report">
              <IconButton 
                disabled={downloadDisabled}  
                backgroundColorVariant='none' 
                icon={<PictureAsPdfIcon fontSize='large' style={{color:theme.color.primary}}/>} 
                onClick={onDownloadReport}/>
            </Tooltip>
          </div>
        </div>
    </Card>
  )
}